import { FILTER_LABEL } from "../../../constants";

export const userPermissionsConstants = {
  USER_PERMISSION_DATA: "USER_PERMISSION_DATA",
  PERMISSION_DATA: "PERMISSION_DATA",
  UPDATE_USER_PERMISSION: "UPDATE_USER_PERMISSION",
  USER_PERMISSION_DELETED: "USER_PERMISSION_DELETED",
  USER_DATA: "USER_DATA",
  RESET_PASSWORD_USER_PERMISSION: "RESET_PASSWORD_USER_PERMISSION",
  RESET_PASSWORD_USER_PERMISSION_SPINNER:
    "RESET_PASSWORD_USER_PERMISSION_SPINNER",
  VERIFY_PASSWORD: "VERIFY_PASSWORD",
  ROLE: "roleId",
  SUPER_ADMIN: "SuperAdmin",
  BRAND_ADMIN: "BrandAdmin",
  GROUP: "Group",
  USER: "User",
  MANAGER: "Manager",
  MANAGERS: "Managers",
  STORE_IDS: "storeIds",
  MANAGER_ID: "managerId",
  PROFILE_TYPE: "Profile Type",
  BRANDS: "Brands",
  ALL_BRANDS: FILTER_LABEL.ALL_BRANDS,
  BRAND_LOCATIONS: "Brand Locations",
  GROUPS: "Groups",
  FRANCHISE_ID: "groupId",
  BRAND_LOCATIONS_ID: "brandLocationId",
  SELECT_USER_TYPE: "Select the user type",
  GET_USER_PERMISSION_EMAILS: "GET_USER_PERMISSION_EMAILS",
  ALL: FILTER_LABEL.ALL,
  GROUP_ID: "groupId",
  SEARCH_DEBOUNCE_MS: 1000,
  DELETE_USER_MESSAGE: "Are you sure you want to delete user details?",
};

export const userFilterDropDown = [
  {
    value: "",
    name: FILTER_LABEL.ALL_PROFILE_TYPES,
  },
  {
    value: "1",
    name: "Super Admin",
  },
  {
    value: "2",
    name: "Brand Admin",
  },
  {
    value: "3",
    name: "Group Admin",
  },
  {
    value: "5",
    name: "Manager",
  },
  {
    value: "6",
    name: "Email Only",
  },
];

export const userProfileDropDown = [
  {
    value: 1,
    name: "Super Admin",
  },
  {
    value: 2,
    name: "Brand Admin",
  },
  {
    value: 3,
    name: "Group Admin",
  },
  {
    value: 5,
    name: "Manager",
  },
  {
    value: 6,
    name: "Email Only",
  },
];

export const userSuperAdminDropDown = [
  {
    value: 2,
    name: "Brand Admin",
  },
  {
    value: 3,
    name: "Group Admin",
  },
  {
    value: 5,
    name: "Manager",
  },
  {
    value: 6,
    name: "Email Only",
  },
];

export const userBrandDropDown = [
  {
    value: 2,
    name: "Brand Admin",
  },
  {
    value: 3,
    name: "Group Admin",
  },
  {
    value: 5,
    name: "Manager",
  },
];

export const franchiseDropDown = [
  {
    value: 3,
    name: "Group Admin",
  },
  {
    value: 5,
    name: "Manager",
  },
];

export const userDropDown = [
  {
    value: 4,
    name: "User",
  },
];
export const managerDropDown = [
  {
    value: 5,
    name: "Manager",
  },
];

//Constants for user permission input fields
export const userPermissionsFieldsNames = {
  PASSWORD: "password",
  BRAND_ID: "brandId",
  BRAND_IDS: "brandIds",
  PHONE_NUMBER: "phoneNumber",
  NEW_PASSWORD: "newPassword",
};

export const userPermissionHeadingNames = {
  ADD_NEW_USER: "Add New User",
  EDIT_USER: "Edit User",
};

//Constant for profile type dropdown on usernoification screen
export const profileTypeDropdownNames = {
  SUPER_ADMIN: "Super Admin",
  BRAND_ADMIN: "Brand Admin",
  GROUP: "Group",
  USER: "User",
  MANAGER: "Manager",
  EMAIL_ONLY: "Email Only",
};

//Enums for user permissions page role
export const roleTypeEnums = {
  SUPER_ADMIN: 1,
  BRAND_ADMIN: 2,
  GROUP: 3,
  USER: 4,
  MANAGER: 5,
  EMAIL_ONLY: 6,
};

export const franchiseOptionLabel = {
  ADD: "add",
  ADD_FRANCHISE: "+add Group",
};

export const managerOptionLabel = {
  ADD_MANAGER: "+add Manager",
};

export const filteringOptions = {
  [userPermissionsConstants.SUPER_ADMIN]: [],
  [userPermissionsConstants.BRAND_ADMIN]: [roleTypeEnums.SUPER_ADMIN],
  [userPermissionsConstants.GROUP]: [
    roleTypeEnums.SUPER_ADMIN,
    roleTypeEnums.BRAND_ADMIN,
  ],
  [userPermissionsConstants.USER]: [
    roleTypeEnums.SUPER_ADMIN,
    roleTypeEnums.BRAND_ADMIN,
    roleTypeEnums.GROUP,
    roleTypeEnums.MANAGER,
  ],
  [userPermissionsConstants.MANAGER]: [
    roleTypeEnums.SUPER_ADMIN,
    roleTypeEnums.BRAND_ADMIN,
    roleTypeEnums.GROUP,
  ],
};

export const ProfileNameText = {
  [roleTypeEnums.SUPER_ADMIN]: "Super Admin",
  [roleTypeEnums.BRAND_ADMIN]: "Brand Admin",
  [roleTypeEnums.GROUP]: "Group Admin",
  [roleTypeEnums.MANAGER]: "Manager",
  [roleTypeEnums.EMAIL_ONLY]: "Email Only",
};
